// extracted by mini-css-extract-plugin
export default {"card":"VenueCard_card__1-Su8","place":"VenueCard_place__TgIPu","img":"VenueCard_img__60gfT"};